import { Component, OnInit, OnDestroy, Input, Output, ViewChild, ElementRef } from '@angular/core'
import { OrganizationDataGateway } from '../../gatewasys/organization-data.gateway'
import { OrgBrowserOrgList } from '../../models/org-browser-org-list'
import { OrgBrowserView } from '../../models/org-browser-view'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
import { CurrentUser } from '../../../common/models/current-user'
import { OrgListContainerComponent } from './org-list-container.component'
import { OrgSearchComponent } from './org-search.component'
import { MyClientsSavedSearch } from '../../models/myclients-saved-search'
import { MyClientsCriteria } from '../../models/my-clients-criteria'
import * as moment from 'moment'
import { ReportsGateway } from '../../gatewasys/reports.gateway'
import { Router } from '@angular/router'
import { PortalGlobals } from '../../../portalglobals'
@Component({
    selector: 'clients-report',
    templateUrl: './clients-report.component.html',
    styleUrls: ['./clients-report.component.scss']
})
export class ClientsReportComponent implements OnInit, OnDestroy {
    orgDropDownVisible: boolean
    orgTree: OrgBrowserOrgList[] = [] as OrgBrowserOrgList[]
    rootOrgId: number
    currentUser: CurrentUser
    newSearchName: string = 'New Search(unsaved)'
    searchSummaryExpanded: boolean = true
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef

    @ViewChild('orgListContainer')
    private orgListContainer: OrgListContainerComponent

    @ViewChild('orgSearch')
    private orgSearch: OrgSearchComponent

    savedSearches: MyClientsSavedSearch[]
    selectedSearch: MyClientsSavedSearch
    newSearchOption: MyClientsSavedSearch
    myClientsCriteria: MyClientsCriteria
    error: boolean = false
    errorMessage: string = ''
    selectedOrgValue: string = ''
    selectedOrgsVisible: boolean = false
    isAdmin: boolean
    isAetnaOrg: boolean
    resetSearch: string
    orglistRefresh: string
    IsMedicareIDClick: boolean = false
    startdate: string
    endate: string
    isMyClientsAUEnabled: boolean = false

    constructor(
        private routers: Router,
        private orgGateway: OrganizationDataGateway,
        private currentUserGateway: CurrentUserGateway,
        private reportsGateway: ReportsGateway,
        private _globals: PortalGlobals
    ) {}

    ngOnInit() {
        this.myClientsCriteria = this.reportsGateway.myClientsCriteria
        this.myClientsCriteria.ReportCategory = ''
        this.orgDropDownVisible = false
        this.isAdmin = false
        if (
            this.myClientsCriteria.ApplicationStartDate === '' ||
            this.myClientsCriteria.ApplicationStartDate === undefined ||
            this.myClientsCriteria.ApplicationStartDate === null
        ) {
            this.myClientsCriteria.ApplicationStartDate = '10/01/2005'
            this.myClientsCriteria.ApplicationEndDate = moment().format('MM/DD/YYYY')
        }

        if (JSON.parse(localStorage.getItem('clientCriteria')!) === undefined || JSON.parse(localStorage.getItem('clientCriteria')!) === null) {
            this.createNewSearch()
            this.loadCurrentUser()
        } else {
            this.myClientsCriteria = JSON.parse(localStorage.getItem('clientCriteria')!)
            this.loadCurrentUserOnRefresh()
            this.startdate = this.myClientsCriteria.ApplicationStartDate
            this.endate = this.myClientsCriteria.ApplicationEndDate

            this.myClientsCriteria.ApplicationStartDate = moment(this.startdate).format('M/D/YYYY')
            this.myClientsCriteria.ApplicationEndDate = moment(this.endate).format('M/D/YYYY')

            this.setOrgValueOnRefresh(this.myClientsCriteria.ReportType)
        }
        this.IsMedicareIDClick = false
    }

    loadCurrentUserOnRefresh(): void {
        this.currentUser = JSON.parse(localStorage.getItem('reportuser')!)

        if (this.currentUser != null && this.currentUser.orgId != null) {
            this.rootOrgId = parseInt(this.currentUser.orgId, 10)
            this.myClientsCriteria.InsuranceCompany = this.currentUser.insuranceCompanyName
            this.isAdmin = this.currentUser.IsAdmin
            this.isAetnaOrg = this.currentUser.AetnaInd
            if (this.isAdmin === false) {
                if (
                    this.currentUser.roleCode === 'Organization Manager' ||
                    this.currentUser.roleCode === 'Organization Admin' ||
                    this.currentUser.roleCode === 'Admin / Agent' ||
                    this.currentUser.AetnaInd === true
                ) {
                    this.isAdmin = true
                }
            }
            if (!this.isAdmin) {
                this.myClientsCriteria.AgentID = this.currentUser.userProfileName
            }
            this.myClientsCriteria.LoginProfileID = this.currentUser.userProfileId.toString()
            this.myClientsCriteria.OrgID = +this.currentUser.orgId
            if (
                this.myClientsCriteria.ApplicationStartDate === '' ||
                this.myClientsCriteria.ApplicationStartDate === undefined ||
                this.myClientsCriteria.ApplicationStartDate === null
            ) {
                this.myClientsCriteria.ApplicationStartDate = '10/01/2005'
                this.myClientsCriteria.ApplicationEndDate = moment().format('MM/DD/YYYY')
            }

            this.loadAUReportFlag(this.currentUser.userProfileId)
        } else {
            console.log('current user is undefined')
        }
    }

    loadAUReportFlag(userProfileId: number) {
        this.reportsGateway.getAlternativeReportingEnabled(userProfileId).subscribe((enabled: boolean) => {
            this.isMyClientsAUEnabled = enabled
        })
    }

    setOrgValueOnRefresh(value: any): void {
        this.selectedOrgValue = value

        if (this.selectedOrgValue === 'ALL' || this.selectedOrgValue === 'ALLACTIVE' || this.selectedOrgValue === 'CUSTOM') {
            this.resetSearch = value
            this.selectedOrgsVisible = true
            const insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()
            //  this.routers.navigateByUrl('/' + insCo + '/reports/my-clients')
        }

        switch (this.selectedOrgValue) {
            case 'ALLACTIVE':
                this.myClientsCriteria.ReportType = this.selectedOrgValue
                if (this.currentUser !== undefined && this.currentUser !== null) {
                    this.createNewSearch()
                    this.myClientsCriteria.ReportCategory = 'ALL'
                    this.selectedSearch.selectedOrgs = JSON.parse(localStorage.getItem('OrgData')!)
                    this.getSelectedOrgs()
                    this.hideOrgDropDown()
                }
                break
            case 'ALL':
                this.myClientsCriteria.ReportType = this.selectedOrgValue
                if (this.currentUser !== undefined && this.currentUser !== null) {
                    this.createNewSearch()
                    this.myClientsCriteria.ReportCategory = 'ALL'
                    this.selectedSearch.selectedOrgs = JSON.parse(localStorage.getItem('OrgData')!)
                    this.getSelectedOrgs()
                    this.hideOrgDropDown()
                }
                break
            case 'CUSTOM':
                this.myClientsCriteria.ReportType = this.selectedOrgValue
                this.myClientsCriteria.ReportCategory = 'ALL'
                this.myClientsCriteria.OrgList = ''
                this.showOrgDropDown()
                this.createNewSearch()
                this.selectedSearch.selectedOrgs = JSON.parse(localStorage.getItem('OrgData')!)
                this.getSelectedOrgs()
                break
            default:
                this.selectedOrgsVisible = false
                break
        }
    }
    ngOnDestroy() {
        if (this.IsMedicareIDClick === false) localStorage.removeItem('clientCriteria')

        localStorage.removeItem('countCriteria')
    }

    setOrgValue(value: any): void {
        localStorage.removeItem('clientCriteria')
        this.selectedOrgValue = value

        if (this.selectedOrgValue === 'ALL' || this.selectedOrgValue === 'ALLACTIVE' || this.selectedOrgValue === 'CUSTOM') {
            this.resetSearch = value

            this.selectedOrgsVisible = true
            const insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()
            this.routers.navigateByUrl('/' + insCo + '/reports/my-clients')
        }

        switch (this.selectedOrgValue) {
            case 'ALLACTIVE':
                this.myClientsCriteria.ReportType = this.selectedOrgValue
                if (this.currentUser !== undefined && this.currentUser !== null) {
                    this.createNewSearch()
                    if (this.currentUser.AetnaInd) {
                        if (this.currentUser.IsAdmin) {
                            if (this.currentUser.ParentPWEntityId === undefined || this.currentUser.ParentPWEntityId === null) {
                                this.refreshPWOrgTree(this.rootOrgId, true, true)
                            } else {
                                this.refreshPWOrgTree(this.currentUser.ParentPWEntityId, true, true)
                            }
                        } else {
                            this.refreshPWOrgTree(this.currentUser.PWEntityId, true, true)
                        }
                    } else {
                        this.refreshOrgTree(this.rootOrgId, true, true)
                    }
                    this.myClientsCriteria.ReportCategory = 'ALL'
                    this.hideOrgDropDown()
                }
                break
            case 'ALL':
                this.myClientsCriteria.ReportType = this.selectedOrgValue
                if (this.currentUser !== undefined && this.currentUser !== null) {
                    this.createNewSearch()
                    if (this.currentUser.AetnaInd) {
                        if (this.currentUser.IsAdmin) {
                            if (this.currentUser.ParentPWEntityId === undefined || this.currentUser.ParentPWEntityId === null) {
                                this.refreshPWOrgTreeAll(this.rootOrgId, true, false)
                            } else {
                                this.refreshPWOrgTreeAll(this.currentUser.ParentPWEntityId, true, false)
                            }
                        } else {
                            this.refreshPWOrgTreeAll(this.currentUser.PWEntityId, true, false)
                        }
                    } else {
                        this.refreshOrgTree(this.rootOrgId, true, false)
                    }
                    this.myClientsCriteria.ReportCategory = 'ALL'
                    this.hideOrgDropDown()
                }
                break
            case 'CUSTOM':
                this.myClientsCriteria.ReportType = this.selectedOrgValue
                this.createNewSearch()
                this.myClientsCriteria.ReportCategory = 'ALL'
                this.myClientsCriteria.OrgList = ''
                this.showOrgDropDown()
                break
            default:
                this.selectedOrgsVisible = false
                break
        }
    }

    reportCategoryText(): string {
        if (this.selectedOrgValue === 'ALL') {
            return 'All Organizations'
        } else if (this.selectedOrgValue === 'ALLACTIVE') {
            return 'All Active Organizations'
        } else if (this.selectedOrgValue === 'CUSTOM') {
            return 'Selected Organizations'
        } else {
            return 'None'
        }
    }

    toggleSearchSummary(): void {
        this.searchSummaryExpanded = !this.searchSummaryExpanded
    }

    loadCurrentUser(): void {
        if (this._globals !== undefined && this._globals.currentUser !== undefined) {
            this.processCurrentUser(this._globals.currentUser)
        } else {
            this.currentUserGateway.getCurrentUser().subscribe(
                (user: CurrentUser) => {
                    this.processCurrentUser(user)
                },
                (error) => {
                    console.log(error)
                }
            )
        }
    }

    processCurrentUser(user: CurrentUser) {
        this.currentUser = user
        this.loadAUReportFlag(this.currentUser.userProfileId)
        localStorage.setItem('reportuser', JSON.stringify(this.currentUser))
        if (this.currentUser != null && this.currentUser.orgId != null) {
            this.rootOrgId = parseInt(this.currentUser.orgId, 10)
            this.myClientsCriteria.InsuranceCompany = this.currentUser.insuranceCompanyName
            this.isAdmin = this.currentUser.IsAdmin
            this.isAetnaOrg = this.currentUser.AetnaInd
            if (this.isAdmin === false) {
                if (
                    this.currentUser.roleCode === 'Organization Manager' ||
                    this.currentUser.roleCode === 'Organization Admin' ||
                    this.currentUser.roleCode === 'Admin / Agent'
                ) {
                    this.isAdmin = true
                }
            }
            if (!this.isAdmin) {
                this.myClientsCriteria.AgentID = this.currentUser.userProfileName
            }
            this.myClientsCriteria.LoginProfileID = this.currentUser.userProfileId.toString()
            this.myClientsCriteria.OrgID = +this.currentUser.orgId
            if (
                this.myClientsCriteria.ApplicationStartDate === '' ||
                this.myClientsCriteria.ApplicationStartDate === undefined ||
                this.myClientsCriteria.ApplicationStartDate === null
            ) {
                this.myClientsCriteria.ApplicationStartDate = '10/01/2005'
                this.myClientsCriteria.ApplicationEndDate = moment().format('MM/DD/YYYY')
            }
        } else {
            console.log('current user is undefined')
        }
    }

    createSavedSearches(): void {
        this.savedSearches = [{ searchId: -1, searchName: 'All Organizations' } as MyClientsSavedSearch] as MyClientsSavedSearch[]
    }

    showOrgDropDown(): void {
        this.orgDropDownVisible = true
        setTimeout(() => {
            if (this.orgListContainer !== undefined && this.orgListContainer !== null) {
                if (this.currentUser.AetnaInd === true) {
                    if (this.currentUser.IsAdmin) {
                        if (this.currentUser.ParentPWEntityId === undefined || this.currentUser.ParentPWEntityId === null) {
                            this.orgListContainer.initPWOrgTree(this.rootOrgId, this.currentUser)
                        } else {
                            this.orgListContainer.initPWOrgTree(this.currentUser.ParentPWEntityId, this.currentUser)
                        }
                    } else {
                        this.orgListContainer.initPWOrgTree(this.currentUser.PWEntityId, this.currentUser)
                    }
                } else {
                    this.orgListContainer.initOrgTree(parseInt(this.currentUser.orgId, 10))
                }
            }
        }, 1000)
        //this.createNewSearch();
    }

    showHideOrgDropDown(): void {
        if (this.orgDropDownVisible === true) {
            this.hideOrgDropDown()
        } else {
            this.showOrgDropDown()
        }
    }

    hideOrgDropDown(): void {
        this.orgDropDownVisible = false
    }

    onAddOrgList(orgId: number): void {
        if (this.currentUser.AetnaInd) {
            this.loadPWOrgData(orgId)
        } else {
            this.loadOrgData(orgId)
        }
    }

    loadPWOrgData(orgId: number): void {
        this.orgGateway.getPWOrganization(orgId, orgId).subscribe((currentOrg) => {
            this.orgGateway.getPWOrganizationsForParent(orgId, orgId).subscribe((childOrgs) => {
                const orgList: OrgBrowserOrgList = {
                    currentOrganization: currentOrg,
                    organizations: childOrgs,
                    selectedOrganization: undefined
                } as OrgBrowserOrgList
                if (this.orgTree === undefined || this.orgTree === null) {
                    this.orgTree = [] as OrgBrowserOrgList[]
                }
                this.orgTree = this.orgTree.concat([orgList])
            })
        })
    }

    loadOrgData(orgId: number): void {
        this.orgGateway.getOrganization(orgId).subscribe((currentOrg) => {
            this.orgGateway.getOrganizationsForParent(orgId).subscribe((childOrgs) => {
                const orgList: OrgBrowserOrgList = {
                    currentOrganization: currentOrg,
                    organizations: childOrgs,
                    selectedOrganization: undefined
                } as OrgBrowserOrgList
                if (this.orgTree === undefined || this.orgTree === null) {
                    this.orgTree = [] as OrgBrowserOrgList[]
                }
                this.orgTree = this.orgTree.concat([orgList])
            })
        })
    }

    createNewSearch(): void {
        this.selectedSearch = {
            searchId: -1,
            searchName: 'New Search',
            isAll: false,
            selectedOrgs: [] as OrgBrowserView[]
        } as MyClientsSavedSearch
    }

    searchByMedicareID(): void {
        this.IsMedicareIDClick = true
        localStorage.setItem('clientCriteria', JSON.stringify(this.myClientsCriteria))
        const insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()
        this.routers.navigateByUrl('/' + insCo + '/reports/medicareid-search')
    }

    searchOldEnrollments(): void {
        if (this.isAetnaOrg === true) {
            localStorage.setItem('clientCriteria', JSON.stringify(this.myClientsCriteria))
            const insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()
            this.routers.navigateByUrl('/' + insCo + '/reports/ss-my-clients')
        }
    }

    onInfoChange(fieldName: string, fieldValue: string): void {
        this.myClientsCriteria[fieldName] = fieldValue
    }

    onOrgAdd(org: OrgBrowserView): void {
        this.addOrg(org)
    }

    addOrg(org: OrgBrowserView): void {
        org.includeDownline = true
        this.selectedSearch.selectedOrgs = this.selectedSearch.selectedOrgs.concat([org])
        localStorage.setItem('OrgData', JSON.stringify(this.selectedSearch.selectedOrgs))
    }

    onSearchResultsChanged(orgs: OrgBrowserView[]): void {
        if (
            this.selectedSearch === undefined ||
            this.selectedSearch === null ||
            this.selectedSearch.selectedOrgs === undefined ||
            this.selectedSearch.selectedOrgs === null
        ) {
            return
        }
        this.selectedSearch.selectedOrgs.forEach((o) => {
            orgs.forEach((o2) => {
                if (o.orgId === o2.orgId) {
                    o2.selected = true
                }
            })
        })
    }

    toggleDownline(org: OrgBrowserView): void {
        org.includeDownline = !org.includeDownline
    }

    removeOrg(org: OrgBrowserView): void {
        org.includeDownline = false
        const pos = this.selectedSearch.selectedOrgs.indexOf(org, 0)
        this.selectedSearch.selectedOrgs.splice(pos, 1)
        localStorage.setItem('OrgData', JSON.stringify(this.selectedSearch.selectedOrgs))
        this.orgListContainer.orgUnSelect(org)
        if (this.orgSearch !== null && this.orgSearch !== undefined) {
            this.orgSearch.orgUnSelect(org)
        }
    }

    refreshOrgTree(orgId: number, selectAll: boolean = false, activeOnly: boolean = false): void {
        this.orgGateway.getOrganization(orgId).subscribe((currentOrg) => {
            this.orgGateway.getOrganizationsForParent(orgId).subscribe((childOrgs) => {
                if (activeOnly === false) {
                    childOrgs = [currentOrg].concat(childOrgs)
                }
                if (activeOnly === true) {
                    childOrgs = childOrgs.filter((o) => o.isActive === true)
                }
                const orgList: OrgBrowserOrgList = {
                    currentOrganization: currentOrg,
                    organizations: childOrgs,
                    selectedOrganization: undefined
                } as OrgBrowserOrgList

                if (selectAll === true) {
                    orgList.organizations.forEach((o) => {
                        o.selected = true
                        this.onOrgAdd(o)
                    })
                }
            })
        })
    }

    refreshPWOrgTree(pwEntityId: number, selectAll: boolean = false, activeOnly: boolean = false): void {
        this.orgGateway.getPWOrganization(pwEntityId, pwEntityId).subscribe((currentOrg) => {
            this.orgGateway.getPWOrganizationsForParent(pwEntityId, pwEntityId).subscribe((childOrgs) => {
                if (activeOnly === false) {
                    childOrgs = [currentOrg].concat(childOrgs)
                }
                if (activeOnly === true) {
                    childOrgs = childOrgs.filter((o) => o.isActive === true)
                }
                const orgList: OrgBrowserOrgList = {
                    currentOrganization: currentOrg,
                    organizations: childOrgs,
                    selectedOrganization: undefined
                } as OrgBrowserOrgList

                if (selectAll === true) {
                    orgList.organizations.forEach((o) => {
                        o.selected = true
                        this.onOrgAdd(o)
                    })
                }
            })
        })
    }

    refreshPWOrgTreeAll(pwEntityId: number, selectAll: boolean = false, activeOnly: boolean = false): void {
        this.orgGateway.getPWOrganization(pwEntityId, pwEntityId).subscribe((currentOrg) => {
            this.orgGateway.getPWOrganizationsForParentAll(pwEntityId, pwEntityId).subscribe((childOrgs) => {
                if (activeOnly === false) {
                    childOrgs = [currentOrg].concat(childOrgs)
                }
                if (activeOnly === true) {
                    childOrgs = childOrgs.filter((o) => o.isActive === true)
                }
                const orgList: OrgBrowserOrgList = {
                    currentOrganization: currentOrg,
                    organizations: childOrgs,
                    selectedOrganization: undefined
                } as OrgBrowserOrgList

                if (selectAll === true) {
                    orgList.organizations.forEach((o) => {
                        o.selected = true
                        this.onOrgAdd(o)
                    })
                }
            })
        })
    }

    onGetEnrollments() {
        this.errorMessage = ''
        if (
            this.myClientsCriteria === undefined ||
            this.myClientsCriteria.ApplicationEndDate === undefined ||
            this.myClientsCriteria.ApplicationStartDate === undefined ||
            this.myClientsCriteria.ApplicationStartDate === null ||
            this.myClientsCriteria.ApplicationEndDate === null
        ) {
            this.error = true
            this.errorMessage = 'Application Start/End date is required.'
            this.focusableEleTop.nativeElement.focus()
            return
        }

        if (
            (this.myClientsCriteria.AgentID === undefined ||
                this.myClientsCriteria.AgentID === null ||
                this.myClientsCriteria.AgentID.trim() === '') &&
            (this.selectedSearch === undefined ||
                this.selectedSearch === null ||
                this.selectedSearch.selectedOrgs === undefined ||
                this.selectedSearch.selectedOrgs === null ||
                this.selectedSearch.selectedOrgs.length <= 0)
        ) {
            this.error = true
            this.errorMessage = 'Organizations are required'
            this.focusableEleTop.nativeElement.focus()
            return
        }

        this.error = false
        this.errorMessage = ''

        if (this.selectedSearch !== undefined) {
            if (this.selectedSearch.selectedOrgs !== null && this.selectedSearch.selectedOrgs.length > 0) {
                this.selectedSearch.selectedOrgs = JSON.parse(localStorage.getItem('OrgData')!)
                this.orglistRefresh = this.selectedSearch.selectedOrgs.map((o) => o.orgId.toString()).join()

                this.myClientsCriteria.OrgList = this.selectedSearch.selectedOrgs.map((o) => o.orgId.toString()).join()
                if (this.orglistRefresh !== this.myClientsCriteria.OrgList) {
                    localStorage.removeItem('OrgData')
                }
            }
        }

        this.reportsGateway.myClientsCriteria = this.myClientsCriteria
        const insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()
        this.routers.navigateByUrl('/' + insCo + '/reports/my-clients').then((value) => {
            if (value) this.routers.navigateByUrl('/' + insCo + '/reports/my-clients/counts')
            else this.routers.navigateByUrl('/' + insCo + '/reports/my-clients/counts')
        })
    }

    getSelectedOrgs(): OrgBrowserView[] {
        if (
            this.selectedSearch === undefined ||
            this.selectedSearch === null ||
            this.selectedSearch.selectedOrgs === undefined ||
            this.selectedSearch.selectedOrgs === null
        ) {
            return [] as OrgBrowserView[]
        }
        const activeOrgs: OrgBrowserView[] = this.selectedSearch.selectedOrgs
            .filter((o) => o.isActive === true)
            .sort((a: OrgBrowserView, b: OrgBrowserView) => {
                if (a.orgName > b.orgName) {
                    return 1
                } else if (a.orgName < b.orgName) {
                    return -1
                } else {
                    return 0
                }
            })

        const inactiveOrgs: OrgBrowserView[] = this.selectedSearch.selectedOrgs
            .filter((o) => o.isActive === false)
            .sort((a: OrgBrowserView, b: OrgBrowserView) => {
                if (a.orgName > b.orgName) {
                    return 1
                } else if (a.orgName < b.orgName) {
                    return -1
                } else {
                    return 0
                }
            })
        return activeOrgs.concat(inactiveOrgs)
    }
    //onReset(title: string) {
    //    this.resetSearch =title
    //    console.log(title)

    //}
}
